export default {
      id: "accounting-period-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#accounting-period",
      toString: function () {
        return this.url;
      }
    }